module.exports = __webpack_public_path__ + "static/media/laserenisimaLogo.1290450a.png";